import React from 'react';
import { Helmet } from 'react-helmet-async';
import { LandingPage as LandingPageType } from '../../types/landingPage';

interface SeoHeadProps {
  landingPage: LandingPageType;
}

const SeoHead: React.FC<SeoHeadProps> = ({ landingPage }) => {
  const seoTitle = landingPage.meta_title || landingPage.title;
  const seoDescription = landingPage.meta_description || '';
  const keywords = landingPage.keywords || '';
  const currentUrl = window.location.pathname;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      {seoDescription && <meta name="description" content={seoDescription} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      {seoDescription && <meta property="og:description" content={seoDescription} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      {landingPage.hero_featured_image && (
        <meta property="og:image" content={landingPage.hero_featured_image} />
      )}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      {seoDescription && <meta name="twitter:description" content={seoDescription} />}
      {landingPage.hero_featured_image && (
        <meta name="twitter:image" content={landingPage.hero_featured_image} />
      )}

      {/* Canonical URL */}
      <link rel="canonical" href={window.location.href} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": seoTitle,
          "description": seoDescription,
          "url": window.location.href,
          "image": landingPage.hero_featured_image,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": landingPage.location_name,
            "addressCountry": "PL"
          },
          "category": landingPage.category_name
        })}
      </script>
    </Helmet>
  );
};

export default SeoHead;